export function isNotificationDataValid(notificationData) {
  if (
    !notificationData.assetId.length ||
    !notificationData.senderDisplayName ||
    !notificationData.recipientDisplayName.length
  )
    return false;
  return true;
}
